var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSecond = function SvgArrowSecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4.439,
    d: "M.357 15.181H26.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF460F",
    stroke: "currentColor",
    strokeWidth: 2.219,
    d: "M25.87 16.308 13.188 28.096l1.047 1.124 14.749-13.725L14.232 1.768l-1.043 1.11L25.87 14.684l.874.813z"
  })));
};
export default SvgArrowSecond;